import SectionTitle from "../components/SectionTitle";
import Timeline from "../components/Timeline";
import ExperienceIcon from "../components/icons/ExperienceIcon";
import { motion } from "framer-motion";
import { experienceData } from "../data/experience-data";

export default function ExperienceSection() {
  return (
    <motion.section
      initial={{ x: "-100%" }}
      animate={{ x: 0 }}
      transition={{ duration: 0.4, ease: "easeOut" }}
      className="w-full py-5 px-3 sm:px-5"
      id="experience"
    >
      <SectionTitle title="Experience">
        <ExperienceIcon />
      </SectionTitle>
      <Timeline
        timelineIcon={<ExperienceIcon />}
        styleItemLevel="experience-icon"
        items={experienceData}
      />
    </motion.section>
  );
}
